import styled from 'styled-components'
import { Button } from 'semantic-ui-react'

import { ButtonProps } from './types'
import { Popup } from '@/ui'

const ComposedButton = ({
  iconPosition,
  noMargin,
  opacity,
  disabled,
  disabledReason,
  disabledReasonPosition,
  ...rest
}: ButtonProps) => {
  if (disabled && disabledReason) {
    return (
      <Popup
        style={{ whiteSpace: 'pre-wrap' }}
        inverted
        trigger={
          <div>
            <Button disabled={disabled} {...rest} />
          </div>
        }
        content={disabledReason}
        position={disabledReasonPosition}
      />
    )
  }

  return <Button disabled={disabled} {...rest} />
}

const DefaultButton = styled(ComposedButton)<ButtonProps>`
  &&& {
    color: ${props => props.theme.primaryFontColor}99;
    display: flex !important;
    flex-direction: ${props =>
      props.iconPosition === 'right' ? 'row-reverse' : 'row'};
    font-weight: normal;
    font-family: Roboto;
    border: 1px solid #d8dadb;
    height: 2.65em;
    margin: ${props => (props.noMargin ? 0 : '0 .25em 0 0')};
    padding: 0.75rem 1.25rem !important;
    white-space: nowrap;
    box-shadow: none !important;

    &.disabled {
      ${props => (props.opacity ? 'opacity: 1 !important' : '')};
    }

    i.icon {
      display: ${props => (props.loading ? 'none' : 'initial')};
      margin: ${props =>
        props.iconPosition === 'right' ? '-1px 0 0 0 !important' : 'initial'};
      padding-left: ${props =>
        props.iconPosition === 'right' ? '7px' : 'initial'};
      color: ${props =>
        typeof props?.icon === 'object' ? props?.icon?.color : '#012d3e'};
      position: relative;
      cursor: pointer;
      top: 0px;
      left: 0px;
    }

    &.green {
      color: #fff;
    }

    &:not(.green) {
      background-color: ${props =>
        !props.active ? '#fff' : props.theme.primaryColor} !important;
    }

    &:hover:not(.green),
    &.active:not(.green) {
      background-color: ${props => props.theme.primaryColor} !important;
      color: ${props => props.theme.secondaryFontColor} !important;

      i.icon {
        color: ${props => props.theme.secondaryFontColor} !important;
      }
    }

    &.inverted {
      background-color: ${props => props.theme.primaryColor} !important;
      color: ${props => props.theme.secondaryFontColor} !important;
      box-shadow: none !important;

      &:hover {
        background-color: ${props => props.theme.secondaryColor} !important;
        box-shadow: none !important;
      }

      i.icon {
        color: ${props => props.theme.secondaryFontColor};
      }
    }

    &.light-green {
      color: ${props => props.theme.primaryFontColor}99;
      background-color: #e8ffdb !important;
    }
  }
`

export default DefaultButton
